export enum UploadAssetRequestPref {
	ENABLED = 'asset.assetRequestEnabled',
}

export const UPLOAD_ASSET_REQUEST_PAGE_SIZE = 25;
